/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/microsoft-sharepoint" */ '@atlassian/logo-third-party/microsoft-sharepoint'
		).then((m) => m.MicrosoftSharePointIcon),
	{ moduleId: '@atlassian/logo-third-party/microsoft-sharepoint' },
);

const LazyForgePioSharepointIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-sharepoint-dev" */ './utils').then(
			(m) => m.ForgePioSharepointIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-dev/icon' },
);

const LazyForgePioSharepointSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-sharepoint-dev-search-result" */ './utils').then(
			(m) => m.ForgePioSharepointSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-dev/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioSharepointIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgePioSharepointIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const ForgePioSharepointSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgePioSharepointSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
